import $x from '@/utils/$x';

/**
 * 教练薪资结算单-分页查询
 * @param {*} params
 * @returns
 */
export async function coachSalaryStatementPageList(params) {
  return $x.post(
    '/coach/admin/coach/salary/statement/coachSalaryStatementPageList',
    params,
  );
}

/**
 * 教练薪资结算单-新建对账单
 * @param {*} params
 * @returns
 */
export async function newCoachSalaryStatement(params) {
  return $x.post(
    '/coach/admin/coach/salary/statement/newCoachSalaryStatement',
    params,
  );
}

/**
 * 教练薪资结算单-提交对账单
 * @param {*} params
 * @returns
 */
export async function submitCoachSalaryStatement(params) {
  return $x.post(
    '/coach/admin/coach/salary/statement/submitCoachSalaryStatement',
    params,
  );
}

/**
 * 教练薪资结算单-查看对账单
 * @param {*} params
 * @returns
 */
export async function getCoachSalaryStatement(params) {
  return $x.post(
    '/coach/admin/coach/salary/statement/getCoachSalaryStatement',
    params,
  );
}

/**
 * 教练薪资结算单-删除对账单
 * @param {*} params
 * @returns
 */
export async function deleteCoachSalaryStatement(params) {
  return $x.post(
    '/coach/admin/coach/salary/statement/deleteCoachSalaryStatement',
    params,
  );
}

/**
 * 教练薪资结算单-教练分页查询
 * @param {*} params
 * @returns
 */
export async function coachPageList(params) {
  return $x.post('/coach/admin/coach/salary/statement/coachPageList', params);
}

/**
 * 教练薪资结算单-删除教练
 * @param {*} params
 * @returns
 */
export async function deleteCoach(params) {
  return $x.post('/coach/admin/coach/salary/statement/deleteCoach', params);
}

/**
 * 教练薪资结算单-添加教练
 * @param {*} params
 * @returns
 */
export async function addCoach(params) {
  return $x.post('/coach/admin/coach/salary/statement/addCoach', params);
}

/**
 * 教练薪资结算单-添加教练-教练分页查询
 * @param {*} params
 * @returns
 */
export async function addCoachPageList(params) {
  return $x.post(
    '/coach/admin/coach/salary/statement/addCoachPageList',
    params,
  );
}

/**
 * 教练薪资结算单-添加教练-教练分页查询
 * @param {*} params
 * @returns
 */
export async function getCoachList(params) {
  return $x.post('/coach/admin/coach/salary/statement/coachList', params);
}

/**
 * 教练薪资结算单-教练列表-教练课时详情分页查询
 * @param {*} params
 * @returns
 */
export async function coachClassRoomDetailPageList(params) {
  return $x.post('/coach/admin/coach/salary/statement/coachStatement', params);
}
/**
 * 结算单列表>课时详情-手动标记
 * @param {*} params
 * @returns
 */
export async function coachClassUserMark(params) {
  return $x.post('/coach/admin/mark', params);
}

/**
 * 导出结算
 * @param {*} params
 * @returns
 */
export async function coachDataExport(params) {
  return $x.post('/coach/admin/coach/salary/statement/detail/export', params);
}

/**
 * 导出结算列表
 * @param {*} params
 * @returns
 */
export async function coachDataExportList(params) {
  return $x.post(
    '/coach/admin/coach/salary/statement/detail/export/tasks',
    params,
  );
}

/**
 * 结算数据
 * @param {*} params
 * @returns
 */
export async function settlementData(params) {
  return $x.post('/coach/admin/settlementData', params);
}
/**
 * 结算单列表&gt;教练结算单&gt;用户上课明细
 * @param {*} params
 * @returns
 */
export async function settlementUserDetail(params) {
  return $x.post('/coach/admin/settlementUserDetail', params);
}
/**
 * 结算单列表&gt;教练结算单&gt;删除用户
 * @param {*} params
 * @returns
 */
export async function deleteSettlementUser(params) {
  return $x.post('/coach/admin/deleteSettlementUser', params);
}
/**
 * 结算单列表&gt;教练结算单&gt;同步薪资结算单
 * @param {*} params
 * @returns
 */
export async function syncStatement(params) {
  return $x.post('/coach/admin/syncStatement', params);
}

/**
 * 合伙人结算首页
 * @param {*} params
 * @returns
 */
export async function partnerStatementPageList(params) {
  return $x.post('/partner/statement/partnerStatementPageList', params);
}

/**
 * 新建对账单
 * @param {*} params
 * @returns
 */
export async function addPartnerStatement(params) {
  return $x.post('/partner/statement/addPartnerStatement', params);
}

/**
 * 删除对账单
 * @param {*} params
 * @returns
 */
export async function deletePartnerStatement(params) {
  return $x.post('/partner/statement/deletePartnerStatement', params);
}

/**
 * 对账单操作记录
 * @param {*} params
 * @returns
 */
export async function opRecordList(params) {
  return $x.post('/partner/statement/opRecord', params);
}
/**
 * 提交对账单
 * @param {*} params
 * @returns
 */
export async function submitPartnerStatement(params) {
  return $x.post('/partner/statement/submit', params);
}
/**
 * 对账单合伙人详情
 * @param {*} params
 * @returns
 */
export async function statementPartnerDetail(params) {
  return $x.post('/partner/statement/statementPartnerDetail', params);
}
/**
 * 对账单GMV详情
 * @param {*} params
 * @returns
 */
export async function statementGmvDetail(params) {
  return $x.post('/partner/statement/statementGmvDetail', params);
}
/**
 * 手动标记
 * @param {*} params
 * @returns
 */
export async function manualMark(params) {
  return $x.post('/partner/statement/manualMark', params);
}
/**
 * 对账单商家详情
 * @param {*} params
 * @returns
 */
export async function statementTenantDetail(params) {
  return $x.post('/partner/statement/statementTenantDetail', params);
}
/**
 * 刷新对账单
 * @param {*} params
 * @returns
 */
export async function refreshPartnerStatement(params) {
  return $x.post('/partner/statement/refreshPartnerStatement', params);
}
